/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *\
 *                                                                                           *
 *                               Auto-Generated File Warning                                 *
 *                                                                                           *
 *     This file is generated automatically by C# unit tests, do not edit manually!          *
 *                                                                                           *
\* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

/**
 * All current feature flags known by the server.
 * @readonly
 * @enum {string}
 */
export enum FeatureName {
    None = "None",

    /**
     * FIXED LEGACY FEATURE
     *
     * Is enabled: False
     **/
    AccumailComposeNationalDirectoryDev = "AccumailComposeNationalDirectoryDev",

    /**
     * FIXED LEGACY FEATURE
     *
     * Is enabled: True
     **/
    AccumailContactBrowserNationalDirectory = "AccumailContactBrowserNationalDirectory",

    /**
     * FIXED LEGACY FEATURE
     *
     * Is enabled: True
     **/
    AccumailContactBrowserServerSideSearch = "AccumailContactBrowserServerSideSearch",

    /**
     * FIXED LEGACY FEATURE
     *
     * Is enabled: False
     **/
    AccumailDevOnlyUserEmailTemplates = "AccumailDevOnlyUserEmailTemplates",

    /**
     * FIXED LEGACY FEATURE
     *
     * Is enabled: False
     **/
    AccuMailDirectorySearchPrompt = "AccuMailDirectorySearchPrompt",

    /**
     * FIXED LEGACY FEATURE
     *
     * Is enabled: True
     **/
    AccuMailNewPracticeWelcome = "AccuMailNewPracticeWelcome",

    /**
     * FIXED LEGACY FEATURE
     *
     * Is enabled: False
     **/
    AccumailPaginatedApi = "AccumailPaginatedApi",

    /**
     * FIXED LEGACY FEATURE
     *
     * Is enabled: True
     **/
    AccumailPaginatedApiV1 = "AccumailPaginatedApiV1",

    /**
     * FIXED LEGACY FEATURE
     *
     * Is enabled: False
     **/
    AccuMailToolbarContactBrowser = "AccuMailToolbarContactBrowser",

    /**
     * FIXED LEGACY FEATURE
     *
     * Is enabled: True
     **/
    AccumailV1ContactBrowser = "AccumailV1ContactBrowser",

    /**
     * FIXED LEGACY FEATURE
     *
     * Is enabled: True
     **/
    BatchGskFlorey = "BatchGskFlorey",

    /**
     * FIXED LEGACY FEATURE
     *
     * Is enabled: True
     **/
    FlemingPatientResponse = "FlemingPatientResponse",

    /**
     * FIXED LEGACY FEATURE
     *
     * Is enabled: True
     **/
    InboxConsistentFolders = "InboxConsistentFolders",

    /**
     * FIXED LEGACY FEATURE
     *
     * Is enabled: True
     **/
    LikelyToFailMobilesWarningInDesktop = "LikelyToFailMobilesWarningInDesktop",

    /**
     * FIXED LEGACY FEATURE
     *
     * Is enabled: True
     **/
    ScheduleSelfBookLinkNextWorkingHour = "ScheduleSelfBookLinkNextWorkingHour",

    /**
     * FIXED LEGACY FEATURE
     *
     * Is enabled: True
     **/
    SelfBook7DaysExpiryLinks = "SelfBook7DaysExpiryLinks",

    /**
     * FIXED LEGACY FEATURE
     *
     * Is enabled: True
     **/
    SelfBookAppointmentAvailability = "SelfBookAppointmentAvailability",

    /**
     * FIXED LEGACY FEATURE
     *
     * Is enabled: True
     **/
    SelfBookEnterFlowChange = "SelfBookEnterFlowChange",

    /**
     * FIXED LEGACY FEATURE
     *
     * Is enabled: True
     **/
    SelfBookScrapeChangeEmisClinician = "SelfBookScrapeChangeEmisClinician",

    /**
     * FIXED LEGACY FEATURE
     *
     * Is enabled: True
     **/
    UnifiedNavigation = "UnifiedNavigation",

    /**
     * Description: Accumail - Allow amber list
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    AccumailAllowAmberList = "AccumailAllowAmberList",

    /**
     * Description: accuMail - Assign
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    AccuMailAssign = "AccuMailAssign",

    /**
     * Description: accuMail - Attach First
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    AccuMailAttachFirst = "AccuMailAttachFirst",

    /**
     * Description: Accumail - Enable national directory for compose screen
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    AccumailComposeNationalDirectory = "AccumailComposeNationalDirectory",

    /**
     * Description: accuMail - Opt-out of message GP conversation screen
     *
     * Scope: OrgOnly
     *
     * Allowed for unapproved users: True
     *
     **/
    AccuMailDisableMessageGPConversation = "AccuMailDisableMessageGPConversation",

    /**
     * Description: accuMail - Disable web initiated
     *
     * Scope: OrgOnly
     *
     * Allowed for unapproved users: False
     *
     **/
    AccuMailDisableWebInitiated = "AccuMailDisableWebInitiated",

    /**
     * Description: accuMail - Generate reply link
     *
     * Scope: Any
     *
     * Allowed for unapproved users: True
     *
     **/
    AccuMailGenerateReplyLink = "AccuMailGenerateReplyLink",

    /**
     * Description: Message GP Prompting Experiment
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    AccumailMessageGPPromptingExperiment = "AccumailMessageGPPromptingExperiment",

    /**
     * Description: DO NOT USE: Old Accumail Sandbox
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    AccumailSandboxWebInbox = "AccumailSandboxWebInbox",

    /**
     * Description: Displays the WebView compose, disabling WPF compose
     *
     * Scope: Any
     *
     * Allowed for unapproved users: True
     *
     **/
    AccurxDesktopEmbeddedCompose = "AccurxDesktopEmbeddedCompose",

    /**
     * Description: Internal Use Only: Shows the embedded WebView compose alongside the existing WPF compose
     *
     * Scope: Any
     *
     * Allowed for unapproved users: True
     *
     **/
    AccurxDesktopEmbeddedComposeParallelMode = "AccurxDesktopEmbeddedComposeParallelMode",

    /**
     * Description: Enables the Accurx Desktop embedded Unified Inbox, replacing the WPF Inbox in the Toolbar
     *
     * Scope: Any
     *
     * Allowed for unapproved users: True
     *
     **/
    AccurxDesktopEmbeddedUnifiedInbox = "AccurxDesktopEmbeddedUnifiedInbox",

    /**
     * Description: Internal use only: enables the Accurx Desktop embedded Unified Inbox in parallel with the WPF Inbox
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    AccurxDesktopEmbeddedUnifiedInboxParallelMode = "AccurxDesktopEmbeddedUnifiedInboxParallelMode",

    /**
     * Description: Patient Triage Feature flag
     *
     * Is in modules: Patient Triage
     *
     * Scope: OrgOnly
     *
     * Allowed for unapproved users: False
     *
     **/
    AccurxPlusPatientTriage = "AccurxPlusPatientTriage",

    /**
     * Description: accuRx Plus - Sms Plus Limits Warning
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    AccuRxPlusSmsPlusLimitsWarning = "AccuRxPlusSmsPlusLimitsWarning",

    /**
     * Description: Enables the Accurx Web embedded Unified Inbox, replacing the Accurx Web Inbox
     *
     * Scope: Any
     *
     * Allowed for unapproved users: True
     *
     **/
    AccurxWebEmbeddedUnifiedInbox = "AccurxWebEmbeddedUnifiedInbox",

    /**
     * Description: Active Directory Integration - Login
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    ActiveDirectoryIntegrationLogin = "ActiveDirectoryIntegrationLogin",

    /**
     * Description: Allows multiple workspaces per EMR
     *
     * Scope: OrgOnly
     *
     * Allowed for unapproved users: True
     *
     **/
    AllowMultipleWorkspacesPerEMR = "AllowMultipleWorkspacesPerEMR",

    /**
     * Description: Displays the Ambient Scribe feature on Desktop
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    AmbientScribeDesktop = "AmbientScribeDesktop",

    /**
     * Description: Displays the Ambient Scribe feature on Web
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    AmbientScribeWeb = "AmbientScribeWeb",

    /**
     * Description: Appointment Reminders Clinician column
     *
     * Scope: OrgOnly
     *
     * Allowed for unapproved users: False
     *
     **/
    AppointmentReminderClinicianName = "AppointmentReminderClinicianName",

    /**
     * Description: Appointment Reminders Alpha
     *
     * Is in modules: Batch Messaging and Appointment Reminders
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    AppointmentRemindersAlpha = "AppointmentRemindersAlpha",

    /**
     * Description: Appointment Reminders Configuration UI with amendment options v1
     *
     * Scope: OrgOnly
     *
     * Allowed for unapproved users: False
     *
     **/
    AppointmentRemindersConfigAmendmentsUIv1 = "AppointmentRemindersConfigAmendmentsUIv1",

    /**
     * Description: Appointment Reminders Enable Clinician Compare on Scraping
     *
     * Scope: OrgOnly
     *
     * Allowed for unapproved users: False
     *
     **/
    AppointmentRemindersEnableClinicianCompareOnScraping = "AppointmentRemindersEnableClinicianCompareOnScraping",

    /**
     * Description: Appointment Reminders have implicit consent and hence do not need to check consent when fetching demographics
     *
     * Scope: OrgOnly
     *
     * Allowed for unapproved users: False
     *
     **/
    AppointmentRemindersHasImplicitConsent = "AppointmentRemindersHasImplicitConsent",

    /**
     * Description: Appointment Reminders show location face to face reminder in single site workspace
     *
     * Scope: OrgOnly
     *
     * Allowed for unapproved users: False
     *
     **/
    AppointmentRemindersShowLocationInSingleSiteWorkspace = "AppointmentRemindersShowLocationInSingleSiteWorkspace",

    /**
     * Description: Appointment Reminders use clinic codes to create new reminder
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    AppointmentRemindersUseClinicCodes = "AppointmentRemindersUseClinicCodes",

    /**
     * Description: Appointment Reminders use telephone and video copy in reminder text
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    AppointmentRemindersUseTelephoneAndVideoCopy = "AppointmentRemindersUseTelephoneAndVideoCopy",

    /**
     * Description: accuMail - Attach Patient Record
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    AttachPatientRecord = "AttachPatientRecord",

    /**
     * Description: Audit response of GetOrganisationMetadata request to S1 for support case
     *
     * Scope: OrgOnly
     *
     * Allowed for unapproved users: False
     *
     **/
    AuditS1OrgansationMetadataResponse = "AuditS1OrgansationMetadataResponse",

    /**
     * Description: Web - Auto-Approve Users when matched PDS Mobile number message threshold passed.
     *
     * Scope: OrgOnly
     *
     * Allowed for unapproved users: True
     *
     **/
    AutoApproveUsersWhenMatchedPdsMobileNumberMessageThresholdPassed = "AutoApproveUsersWhenMatchedPdsMobileNumberMessageThresholdPassed",

    /**
     * Description: TRUSTS ONLY - Auto mark tickets for an org as done after 30 days of inaction. Clinical have only approved this for Trusts
     *
     * Scope: OrgOnly
     *
     * Allowed for unapproved users: False
     *
     **/
    AutoMarkAsDone = "AutoMarkAsDone",

    /**
     * Description: Batch Messaging Alpha
     *
     * Is in modules: Batch Messaging and Appointment Reminders, Web - Batch Messaging
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    BatchMessagingAlpha = "BatchMessagingAlpha",

    /**
     * Description: Batch Messaging Florey
     *
     * Is in modules: Batch Messaging and Appointment Reminders, Web - Batch Messaging
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    BatchMessagingFlorey = "BatchMessagingFlorey",

    /**
     * Description: Allow sending questionnaire and sms message batches to patients via NHS App - for national rollout
     *
     * Scope: OrgOnly
     *
     * Allowed for unapproved users: False
     *
     **/
    BatchNhsAppMessagingNationalRollout = "BatchNhsAppMessagingNationalRollout",

    /**
     * Description: Batch Self-book - Access for new Self-book Batch
     *
     * Is in modules: Self Book Batch, Web - Batch Messaging
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    BatchSelfBook = "BatchSelfBook",

    /**
     * Description: Behavioural Change Alpha Group A
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    BehaviouralChangeAlphaA = "BehaviouralChangeAlphaA",

    /**
     * Description: Behavioural Change Alpha Group B
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    BehaviouralChangeAlphaB = "BehaviouralChangeAlphaB",

    /**
     * Description: Behavioural Change - Log shingles vaccine invitation opportunities
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    BehaviouralChangeShinglesControl = "BehaviouralChangeShinglesControl",

    /**
     * Description: Behavioural Change - Shingles vaccine invitation prompt display
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    BehaviouralChangeShinglesPrompt = "BehaviouralChangeShinglesPrompt",

    /**
     * Description: Bulk Appointment Import Module Enabled
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    BulkAppointmentImportModuleEnabled = "BulkAppointmentImportModuleEnabled",

    /**
     * Description: CaregiverInitiated
     *
     * Scope: Any
     *
     * Allowed for unapproved users: True
     *
     **/
    CaregiverInitiated = "CaregiverInitiated",

    /**
     * Description: Integration with CITO Document Store
     *
     * Scope: OrgOnly
     *
     * Allowed for unapproved users: False
     *
     **/
    CitoDocumentStoreIntegration = "CitoDocumentStoreIntegration",

    /**
     * Description: Web - turns on collaborative features like assign and viewing teams and colleagues messages in WebInbox
     *
     * Scope: OrgOnly
     *
     * Allowed for unapproved users: False
     *
     **/
    CollaborativeWebInbox = "CollaborativeWebInbox",

    /**
     * Description: Community Pharmacy Experiment 1
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    CommunityPharmacyExperiment1 = "CommunityPharmacyExperiment1",

    /**
     * Description: Community Pharmacy Experiment 2 - Accumail window
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    CommunityPharmacyExperiment2 = "CommunityPharmacyExperiment2",

    /**
     * Description: Enables the allow reply reminder
     *
     * Scope: Any
     *
     * Allowed for unapproved users: True
     *
     **/
    ComposeAllowReplyReminder = "ComposeAllowReplyReminder",

    /**
     * Description: Content Editor
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    ContentEditor = "ContentEditor",

    /**
     * Description: Content Entity Management
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    ContentEntityManagement = "ContentEntityManagement",

    /**
     * Description: Create MessageLinkNotes
     *
     * Scope: OrgOnly
     *
     * Allowed for unapproved users: False
     *
     **/
    ConversationMessageLinkNotes = "ConversationMessageLinkNotes",

    /**
     * Description: Create Global Custom Florey
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    CreateGlobalCustomFloreys = "CreateGlobalCustomFloreys",

    /**
     * Description: DesktopInboxOrganisationSelector
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    DesktopInboxOrganisationSelector = "DesktopInboxOrganisationSelector",

    /**
     * Description: DesktopOrganisationSelector
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    DesktopOrganisationSelector = "DesktopOrganisationSelector",

    /**
     * Description: DesktopPracticeGroupAssignment
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    DesktopPracticeGroupAssignment = "DesktopPracticeGroupAssignment",

    /**
     * Description: Desktop RudderStack Analytics
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    DesktopRudderStackAnalytics = "DesktopRudderStackAnalytics",

    /**
     * Description: DesktopScreenSearchPds [prototype only]
     *
     * Scope: Any
     *
     * Allowed for unapproved users: True
     *
     **/
    DesktopScreenSearchPds = "DesktopScreenSearchPds",

    /**
     * Description: Desktop Diagnostics On Timer
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    DesktopSendDiagnosticsOnTimer = "DesktopSendDiagnosticsOnTimer",

    /**
     * Description: Disables single send sms and video invites
     *
     * Scope: OrgOnly
     *
     * Allowed for unapproved users: True
     *
     **/
    DisableSingleSendSmsAndVideoInvites = "DisableSingleSendSmsAndVideoInvites",

    /**
     * Description: Disable XAML transparency in desktop
     *
     * Scope: UserOnly
     *
     * Allowed for unapproved users: False
     *
     **/
    DisableTransparencyInDesktop = "DisableTransparencyInDesktop",

    /**
     * Description: Display count of fragments when creating message
     *
     * Scope: OrgOnly
     *
     * Allowed for unapproved users: False
     *
     **/
    DisplayFragmentCountV2 = "DisplayFragmentCountV2",

    /**
     * Description: Display Message GP in Switch
     *
     * Scope: Any
     *
     * Allowed for unapproved users: True
     *
     **/
    DisplayMessageGpInSwitch = "DisplayMessageGpInSwitch",

    /**
     * Description: Display Unified Inbox in Switch
     *
     * Scope: Any
     *
     * Allowed for unapproved users: True
     *
     **/
    DisplayUnifiedInboxInSwitch = "DisplayUnifiedInboxInSwitch",

    /**
     * Description: Enable modals that dissuade users from using My Workspace.
     *
     * Scope: Any
     *
     * Allowed for unapproved users: True
     *
     **/
    DissuadeFromUsingMyWorkspace = "DissuadeFromUsingMyWorkspace",

    /**
     * Description: Embedded PowerBI reporting
     *
     * Alternative names: EmbeddedReportingNewNavigation
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    EmbeddedPowerBiPOC = "EmbeddedPowerBiPOC",

    /**
     * Description: Eagerly load EMIS attachments (when EmisGPSoC enabled)
     *
     * Scope: Any
     *
     * Allowed for unapproved users: True
     *
     **/
    EmisGPSoCEagerlyLoadAttachments = "EmisGPSoCEagerlyLoadAttachments",

    /**
     * Description: EMIS GPSoC - GetMedicalRecord (do not enable)
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    EmisGPSoCGetMedicalRecord = "EmisGPSoCGetMedicalRecord",

    /**
     * Description: EMIS GPSoC via Server
     *
     * Scope: OrgOnly
     *
     * Allowed for unapproved users: False
     *
     **/
    EmisGPSoCServer = "EmisGPSoCServer",

    /**
     * Description: EmisPollCurrentPatientAlways
     *
     * Scope: OrgOnly
     *
     * Allowed for unapproved users: False
     *
     **/
    EmisPollCurrentPatientAlways = "EmisPollCurrentPatientAlways",

    /**
     * Description: Detailed Logging
     *
     * Scope: UserOnly
     *
     * Allowed for unapproved users: False
     *
     **/
    EnableVerboseLogs = "EnableVerboseLogs",

    /**
     * Description: Expanded Patient List (1000)
     *
     * Scope: OrgOnly
     *
     * Allowed for unapproved users: False
     *
     **/
    ExpandedPatientList = "ExpandedPatientList",

    /**
     * Description: accuMail
     *
     * Alternative names: ExternalEmailUploadContactButtonTest
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    ExternalEmail = "ExternalEmail",

    /**
     * Description: Allows default workspace users to create a Flexible Workspace.
     *
     * Scope: OrgOnly
     *
     * Allowed for unapproved users: True
     *
     **/
    FlexibleWorkspace = "FlexibleWorkspace",

    /**
     * Description: Florey
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    Florey = "Florey",

    /**
     * Description: Florey - accuRx Plus
     *
     * Is in modules: Florey Plus
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    FloreyAccuRxPlus = "FloreyAccuRxPlus",

    /**
     * Description: Florey - Alpha Testing (accuRx Users, Dummy Patients)
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    FloreyAlpha = "FloreyAlpha",

    /**
     * Description: Florey - Beta Testing (Selected Clinicians, Dummy Patients)
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    FloreyBeta = "FloreyBeta",

    /**
     * Description: Florey Builder
     *
     * Alternative names: FloreyBuilderAlpha
     *
     * Is in modules: Florey Plus
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    FloreyBuilder = "FloreyBuilder",

    /**
     * Description: Batch Self-book - Limit to 2 fragments
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    FragmentLimitBatchSelfBook = "FragmentLimitBatchSelfBook",

    /**
     * Description: Enable visibility of the Fragments dashboard
     *
     * Scope: OrgOnly
     *
     * Allowed for unapproved users: False
     *
     **/
    FragmentsDashboard = "FragmentsDashboard",

    /**
     * Description: Manage Templates - enables template attachments for GP users
     *
     * Scope: Any
     *
     * Allowed for unapproved users: True
     *
     **/
    GPTemplateAttachments = "GPTemplateAttachments",

    /**
     * Description: Self-book cross org booking
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    HasCrossOrgBooking = "HasCrossOrgBooking",

    /**
     * Description: Web - hide Accurx preset message templates
     *
     * Scope: OrgOnly
     *
     * Allowed for unapproved users: True
     *
     **/
    HidePresetMessageTemplates = "HidePresetMessageTemplates",

    /**
     * Description: Web - Use Html Welcome Email
     *
     * Scope: OrgOnly
     *
     * Allowed for unapproved users: True
     *
     **/
    HtmlWelcomeEmail = "HtmlWelcomeEmail",

    /**
     * Description: Web - Show integrated clinic lists
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    IntegratedClinicLists = "IntegratedClinicLists",

    /**
     * Description: Likely to Fail Numbers as Invalid in Batch
     *
     * Scope: OrgOnly
     *
     * Allowed for unapproved users: False
     *
     **/
    LikelyToFailMobilesAsInvalidInBatch = "LikelyToFailMobilesAsInvalidInBatch",

    /**
     * Description: Enable logging of search patients metadata
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    LogSearchPatientsMetadata = "LogSearchPatientsMetadata",

    /**
     * Description: Multiuser Collaboration
     *
     * Scope: OrgOnly
     *
     * Allowed for unapproved users: True
     *
     **/
    MultiuserCollaboration = "MultiuserCollaboration",

    /**
     * Description: Navigation Desktop Experiment - used to display a new nav icon in the toolbar
     *
     * Scope: Any
     *
     * Allowed for unapproved users: True
     *
     **/
    NavigationDesktopExperiment = "NavigationDesktopExperiment",

    /**
     * Description: Navigation Directory Rollout - used to display Directory button in Primary navigation
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    NavigationWebDirectoryRollout = "NavigationWebDirectoryRollout",

    /**
     * Description: Allow sending Self Book batch messages to patients via NHS App
     *
     * Scope: OrgOnly
     *
     * Allowed for unapproved users: False
     *
     **/
    NhsAppMessagingBatchSelfBook = "NhsAppMessagingBatchSelfBook",

    /**
     * Description: Enable ABC testing option A: This is a reminder for your upcoming appointment
     *
     * Scope: OrgOnly
     *
     * Allowed for unapproved users: False
     *
     **/
    NhsAppSendMessageContextAppointmentReminderA = "NhsAppSendMessageContextAppointmentReminderA",

    /**
     * Description: Enable ABC testing option B: Check your upcoming appointment details
     *
     * Scope: OrgOnly
     *
     * Allowed for unapproved users: False
     *
     **/
    NhsAppSendMessageContextAppointmentReminderB = "NhsAppSendMessageContextAppointmentReminderB",

    /**
     * Description: Enable ABC testing option C: Get ready for your upcoming appointment
     *
     * Scope: OrgOnly
     *
     * Allowed for unapproved users: False
     *
     **/
    NhsAppSendMessageContextAppointmentReminderC = "NhsAppSendMessageContextAppointmentReminderC",

    /**
     * Description: Enable ABC testing option A: New appointment invitation from your GP
     *
     * Scope: OrgOnly
     *
     * Allowed for unapproved users: False
     *
     **/
    NhsAppSendMessageContextBatchSelfBookA = "NhsAppSendMessageContextBatchSelfBookA",

    /**
     * Description: Enable ABC testing option B: Your GP has invited you to book an appointment
     *
     * Scope: OrgOnly
     *
     * Allowed for unapproved users: False
     *
     **/
    NhsAppSendMessageContextBatchSelfBookB = "NhsAppSendMessageContextBatchSelfBookB",

    /**
     * Description: Enable ABC testing option C: Book your appointment now
     *
     * Scope: OrgOnly
     *
     * Allowed for unapproved users: False
     *
     **/
    NhsAppSendMessageContextBatchSelfBookC = "NhsAppSendMessageContextBatchSelfBookC",

    /**
     * Description: Enable NHS login flow for patient portal
     *
     * Scope: OrgOnly
     *
     * Allowed for unapproved users: False
     *
     **/
    NhsLoginForPatientPortal = "NhsLoginForPatientPortal",

    /**
     * Description: Enable OTP for patient portal conversation links
     *
     * Scope: OrgOnly
     *
     * Allowed for unapproved users: False
     *
     **/
    OneTimePasswordsForPatientPortal = "OneTimePasswordsForPatientPortal",

    /**
     * Description: Enable Outcome Recording
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    OutcomeRecording = "OutcomeRecording",

    /**
     * Description: Patient Initiated - Adult ADHD service custom forms
     *
     * Scope: OrgOnly
     *
     * Allowed for unapproved users: False
     *
     **/
    PatientInitiatedAdultAdhdService = "PatientInitiatedAdultAdhdService",

    /**
     * Description: Patient Initiated - Bromley Healthcare Self Referral custom forms
     *
     * Scope: OrgOnly
     *
     * Allowed for unapproved users: False
     *
     **/
    PatientInitiatedBromleyHealthcareSelfReferral = "PatientInitiatedBromleyHealthcareSelfReferral",

    /**
     * Description: Patient Initiated - Central Surrey Healthcare custom forms
     *
     * Scope: OrgOnly
     *
     * Allowed for unapproved users: False
     *
     **/
    PatientInitiatedCentralSurreyHealthcare = "PatientInitiatedCentralSurreyHealthcare",

    /**
     * Description: Patient Initiated Inbox - Desktop Filters for Medical and Admin Requests
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    PatientInitiatedDesktopFiltersMedicalAdminUpgrade = "PatientInitiatedDesktopFiltersMedicalAdminUpgrade",

    /**
     * Description: Patient Initiated - Disable Feedback Form
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    PatientInitiatedDisableFeedbackForm = "PatientInitiatedDisableFeedbackForm",

    /**
     * Description: Patient Initiated - ESHT Podiatry custom forms
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    PatientInitiatedEshtPodiatry = "PatientInitiatedEshtPodiatry",

    /**
     * Description: Patient Initiated - First Community Healthcare Falls Prevention custom forms
     *
     * Scope: OrgOnly
     *
     * Allowed for unapproved users: False
     *
     **/
    PatientInitiatedFirstCommunityHealthcareFallsPrevention = "PatientInitiatedFirstCommunityHealthcareFallsPrevention",

    /**
     * Description: Patient Initiated Inbox
     *
     * Is in modules: Patient Triage
     *
     * Scope: OrgOnly
     *
     * Allowed for unapproved users: False
     *
     **/
    PatientInitiatedInbox = "PatientInitiatedInbox",

    /**
     * Description: Patient Initiated - Disable NHS App
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    PatientInitiatedNhsAppDisable = "PatientInitiatedNhsAppDisable",

    /**
     * Description: Patient Initiated - NHS Login
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    PatientInitiatedNhsLogin = "PatientInitiatedNhsLogin",

    /**
     * Description: Patient Initiated - SCFT OneCall Service custom forms
     *
     * Scope: OrgOnly
     *
     * Allowed for unapproved users: False
     *
     **/
    PatientInitiatedScftOneCallService = "PatientInitiatedScftOneCallService",

    /**
     * Description: Patient Initiated - SCFT Specialist School Nursing custom forms
     *
     * Scope: OrgOnly
     *
     * Allowed for unapproved users: False
     *
     **/
    PatientInitiatedScftSpecialistSchoolNursing = "PatientInitiatedScftSpecialistSchoolNursing",

    /**
     * Description: Patient Initiated - MSK Sussex custom forms
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    PatientInitiatedSussexMsk = "PatientInitiatedSussexMsk",

    /**
     * Description: Patient Initiated - Translations
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    PatientInitiatedTranslations = "PatientInitiatedTranslations",

    /**
     * Description: Patient Initiated - UHCW IBD custom forms
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    PatientInitiatedUhcwIbd = "PatientInitiatedUhcwIbd",

    /**
     * Description: Patient Initiated - UHL Breast surgery custom forms
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    PatientInitiatedUhl = "PatientInitiatedUhl",

    /**
     * Description: Patient Initiated - UHL GEH Colorectal Oncology custom forms
     *
     * Scope: OrgOnly
     *
     * Allowed for unapproved users: False
     *
     **/
    PatientInitiatedUhlGehColorectalOncology = "PatientInitiatedUhlGehColorectalOncology",

    /**
     * Description: Patient Initiated - UHL IBD custom forms
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    PatientInitiatedUhlIbd = "PatientInitiatedUhlIbd",

    /**
     * Description: Web - Enable Patient-led follow up notifications via email
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    PatientInitiatedWebEmailNotification = "PatientInitiatedWebEmailNotification",

    /**
     * Description: PatientListShare
     *
     * Scope: Any
     *
     * Allowed for unapproved users: True
     *
     **/
    PatientListShare = "PatientListShare",

    /**
     * Description: Patient Single Response
     *
     * Alternative names: PatientSingleResponseWithImage
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    PatientSingleResponse = "PatientSingleResponse",

    /**
     * Description: Patient Initiated - Ticket Created From Note
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    PatientThreadCreateTicketFromNote = "PatientThreadCreateTicketFromNote",

    /**
     * Description: Connected Status
     *
     * Scope: Any
     *
     * Allowed for unapproved users: True
     *
     **/
    PatientThreadPushConnected = "PatientThreadPushConnected",

    /**
     * Description: Allow desktop workspaces to create conversations starting with a note
     *
     * Scope: OrgOnly
     *
     * Allowed for unapproved users: False
     *
     **/
    PatientThreads = "PatientThreads",

    /**
     * Description: SMS In Patient Thread
     *
     * Alternative names: SMSAdviceOnly
     *
     * Scope: Any
     *
     * Allowed for unapproved users: True
     *
     **/
    PatientThreadSMS = "PatientThreadSMS",

    /**
     * Description: Team Messaging
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    PatientThreadTeamMessaging = "PatientThreadTeamMessaging",

    /**
     * Description: Patient Initiated Inbox - Split Disabling Medical and Admin
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    PatientTriageAllowAdminRequests = "PatientTriageAllowAdminRequests",

    /**
     * Description: Patient Triage - Dashboards
     *
     * Is in modules: Patient Triage
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    PatientTriageDashboards = "PatientTriageDashboards",

    /**
     * Description: Patient Triage - Live Assignment Dashboards
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    PatientTriageLiveAssignmentDashboards = "PatientTriageLiveAssignmentDashboards",

    /**
     * Description: Patient Triage - Reception Flow
     *
     * Is in modules: Patient Triage
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    PatientTriageReceptionFlow = "PatientTriageReceptionFlow",

    /**
     * Description: Patient Triage - Self Referral Setting
     *
     * Is in modules: Patient Triage
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    PatientTriageSelfReferralSetting = "PatientTriageSelfReferralSetting",

    /**
     * Description: Patient Initiated Inbox - Solicited Appointment Booking
     *
     * Is in modules: Patient Triage
     *
     * Scope: OrgOnly
     *
     * Allowed for unapproved users: False
     *
     **/
    PatientTriageSolicitedAppointmentBooking = "PatientTriageSolicitedAppointmentBooking",

    /**
     * Description: Patient Initiated Inbox - Solicited Appointment Booking Send Link
     *
     * Is in modules: Patient Triage
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    PatientTriageSolicitedAppointmentBookingSendLink = "PatientTriageSolicitedAppointmentBookingSendLink",

    /**
     * Description: Pds search for Desktop Client [prototype only]
     *
     * Alternative names: PdsSearchDemographicsStagingOnlyForNow
     *
     * Scope: Any
     *
     * Allowed for unapproved users: True
     *
     **/
    PdsSearchDemographicsForDesktopClient = "PdsSearchDemographicsForDesktopClient",

    /**
     * Description: Allows perioperative care pilot feature for org
     *
     * Scope: OrgOnly
     *
     * Allowed for unapproved users: False
     *
     **/
    PerioperativeCarePilot = "PerioperativeCarePilot",

    /**
     * Description: PracticeGroups
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    PracticeGroups = "PracticeGroups",

    /**
     * Description: Prevent users from being asked to link their workspace to an NHS Organisation.
     *
     * Scope: OrgOnly
     *
     * Allowed for unapproved users: False
     *
     **/
    PreventWorkspaceMappingFlow = "PreventWorkspaceMappingFlow",

    /**
     * Description: Content Review
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    ReceptionContentReview = "ReceptionContentReview",

    /**
     * Description: Content Search
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    ReceptionStreaming = "ReceptionStreaming",

    /**
     * Description: Record Access - Beta
     *
     * Scope: Any
     *
     * Allowed for unapproved users: True
     *
     **/
    RecordAccessBeta = "RecordAccessBeta",

    /**
     * Description: Record Access No 2FA - for internal use only
     *
     * Scope: UserOnly
     *
     * Allowed for unapproved users: False
     *
     **/
    RecordAccessNoPatient2FA = "RecordAccessNoPatient2FA",

    /**
     * Description: Record View - Florey copy
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    RecordViewFloreyCopy = "RecordViewFloreyCopy",

    /**
     * Description: Record View - GP opted in to sharing records
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    RecordViewGpOptIn = "RecordViewGpOptIn",

    /**
     * Description: Record View - Accumail Latest Consultations
     *
     * Scope: Any
     *
     * Allowed for unapproved users: True
     *
     **/
    RecordViewLatestConsultations = "RecordViewLatestConsultations",

    /**
     * Description: Record View - prompt GP opt in from web
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    RecordViewPromptOptInWeb = "RecordViewPromptOptInWeb",

    /**
     * Description: Restrict archived users to re-join organisation
     *
     * Scope: OrgOnly
     *
     * Allowed for unapproved users: True
     *
     **/
    RestrictAutoJoinArchivedUsers = "RestrictAutoJoinArchivedUsers",

    /**
     * Description: Handle scraping of embargoed slots from S1
     *
     * Scope: OrgOnly
     *
     * Allowed for unapproved users: False
     *
     **/
    ScrapeChangeS1EmbargoedSlots = "ScrapeChangeS1EmbargoedSlots",

    /**
     * Description: Self-book - 12 week scrapes
     *
     * Scope: OrgOnly
     *
     * Allowed for unapproved users: False
     *
     **/
    SelfBook12WeekScrapes = "SelfBook12WeekScrapes",

    /**
     * Description: Self book configuration in webview, version five
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    SelfBookConfigurationWebviewV5 = "SelfBookConfigurationWebviewV5",

    /**
     * Description: Self-Book disable rate-limiting for EMIS scraping
     *
     * Scope: OrgOnly
     *
     * Allowed for unapproved users: False
     *
     **/
    SelfBookDisableScrapeRateLimitingEmis = "SelfBookDisableScrapeRateLimitingEmis",

    /**
     * Description: Self-book enable specific clinician per booking
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    SelfBookEnableSpecificClinicianPerBooking = "SelfBookEnableSpecificClinicianPerBooking",

    /**
     * Description: Self-book - Appointment Scraping
     *
     * Scope: OrgOnly
     *
     * Allowed for unapproved users: False
     *
     **/
    SelfBookFromCompose = "SelfBookFromCompose",

    /**
     * Description: Self-book - SelfBookSending links from compose
     *
     * Is in modules: Self Book Individual
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    SelfBookFromComposeSendLink = "SelfBookFromComposeSendLink",

    /**
     * Description: Self-book ignore scraping on partial failure on Emis
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    SelfBookIgnoreScrapingOnPartialFailureEmis = "SelfBookIgnoreScrapingOnPartialFailureEmis",

    /**
     * Description: Self-book (Inc-566) Verify Appointment Booking Post API Success
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    SelfBookInc566VerifyAppointmentBookingPostApiSuccessV2 = "SelfBookInc566VerifyAppointmentBookingPostApiSuccessV2",

    /**
     * Description: Self-Book navigate patient to single entry page
     *
     * Scope: OrgOnly
     *
     * Allowed for unapproved users: False
     *
     **/
    SelfBookNavigatePatientToSingleEntryPage = "SelfBookNavigatePatientToSingleEntryPage",

    /**
     * Description: Self-book with a specific clinician
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    SelfBookSpecificClinician = "SelfBookSpecificClinician",

    /**
     * Description: SEL Pilot - attempt send SMS messages via NHS App first
     *
     * Scope: OrgOnly
     *
     * Allowed for unapproved users: False
     *
     **/
    SendSmsViaNhsApp = "SendSmsViaNhsApp",

    /**
     * Description: Enable conversations to be redirected via mapped addresses to workspaces
     *
     * Scope: OrgOnly
     *
     * Allowed for unapproved users: False
     *
     **/
    SharedEmailAddressMapping = "SharedEmailAddressMapping",

    /**
     * Description: Attach Documents
     *
     * Scope: Any
     *
     * Allowed for unapproved users: True
     *
     **/
    SmsAttachDocuments = "SmsAttachDocuments",

    /**
     * Description: Store messages in Conversation Message Service
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    StoreMessagesInConversationMessageService = "StoreMessagesInConversationMessageService",

    /**
     * Description: Thread active users
     *
     * Scope: OrgOnly
     *
     * Allowed for unapproved users: True
     *
     **/
    ThreadActiveUsers = "ThreadActiveUsers",

    /**
     * Description: Override unread count of the toolbar with the unread count of the inbox when inbox is open
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    ToolbarUnreadCountOverrideWithInbox = "ToolbarUnreadCountOverrideWithInbox",

    /**
     * Description: Trust Integration - Allows users to generate direct patient urls for trusts EMR
     *
     * Scope: OrgOnly
     *
     * Allowed for unapproved users: False
     *
     **/
    TrustIntegrationLogin = "TrustIntegrationLogin",

    /**
     * Description: Unified Batch Rollout
     *
     * Scope: Any
     *
     * Allowed for unapproved users: True
     *
     **/
    UnifiedBatchRollout = "UnifiedBatchRollout",

    /**
     * Description: Release the Care Providers part of the Unified Inbox
     *
     * Scope: Any
     *
     * Allowed for unapproved users: True
     *
     **/
    UnifiedInboxAccumailSandboxBuild = "UnifiedInboxAccumailSandboxBuild",

    /**
     * Description: Enabling debug mode for investigating the Unified Inbox
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    UnifiedInboxDebugMode = "UnifiedInboxDebugMode",

    /**
     * Description: Debug inconsistent unread counts between inbox and toolbar by turning off new endpoint for unreads
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    UnifiedInboxDebugUnreadCountBySwitchingToInitialUnreads = "UnifiedInboxDebugUnreadCountBySwitchingToInitialUnreads",

    /**
     * Description: Logs unread count mismatch between inbox and toolbar
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    UnifiedInboxLogUnreadCountMismatch = "UnifiedInboxLogUnreadCountMismatch",

    /**
     * Description: Display pending users in the side nav and while reassigning conversations
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    UnifiedInboxPendingUsers = "UnifiedInboxPendingUsers",

    /**
     * Description: Used to temporarily hide questionnaires UI in the inbox while the feature is being built
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    UnifiedInboxQuestionnairesBuild = "UnifiedInboxQuestionnairesBuild",

    /**
     * Description: Add total and unread conversation count tooltips to more inboxes and folders
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    UnifiedInboxTotalConversationCountTooltip = "UnifiedInboxTotalConversationCountTooltip",

    /**
     * Description: Unlimited Attachments
     *
     * Is in modules: SMS Plus, SMS Lite, SMS Non GP Default
     *
     * Scope: OrgOnly
     *
     * Allowed for unapproved users: True
     *
     **/
    UnlimitedAttachments = "UnlimitedAttachments",

    /**
     * Description: Unlimited Patient Responses
     *
     * Is in modules: SMS Plus, SMS Lite, SMS Non GP Default
     *
     * Scope: OrgOnly
     *
     * Allowed for unapproved users: True
     *
     **/
    UnlimitedPatientResponses = "UnlimitedPatientResponses",

    /**
     * Description: Unlimited SMS
     *
     * Is in modules: SMS Plus, SMS Lite, SMS Non GP Default
     *
     * Scope: OrgOnly
     *
     * Allowed for unapproved users: False
     *
     **/
    UnlimitedSms = "UnlimitedSms",

    /**
     * Description: The is a temporary feature flag to manage the changeover to the clinician notification queues
     *
     * Scope: OrgOnly
     *
     * Allowed for unapproved users: False
     *
     **/
    UseClinicianNotificationQueues = "UseClinicianNotificationQueues",

    /**
     * Description: Vaccine Practice - Capacity Checks Use Age
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    VaccineAgeBasedCapacity = "VaccineAgeBasedCapacity",

    /**
     * Description: Vaccine Capacity Overbook
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    VaccineCapacityOverbook = "VaccineCapacityOverbook",

    /**
     * Description: Vaccine Delivery Site
     *
     * Alternative names: VaccinePatientBackendSearch, VaccineBooster
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    VaccineDeliverySite = "VaccineDeliverySite",

    /**
     * Description: Vaccine Delivery Site - Last Minute Cancel
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    VaccineDeliverySiteLastMinuteCancel = "VaccineDeliverySiteLastMinuteCancel",

    /**
     * Description: Vaccine Practice - Access Old View
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    VaccineLegacyPatientList = "VaccineLegacyPatientList",

    /**
     * Description: Vaccine - Paediatric Clinics
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    VaccinePaediatric = "VaccinePaediatric",

    /**
     * Description: Vaccine Practice
     *
     * Alternative names: VaccinePatientBackendSearch, VaccineBooster
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    VaccinePractice = "VaccinePractice",

    /**
     * Description: Vaccine - Autumn 2022 Booster tab
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    VaccinePracticeAutumn2022BoosterTab = "VaccinePracticeAutumn2022BoosterTab",

    /**
     * Description: Vaccine - Autumn 2023 Booster tab
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    VaccinePracticeAutumn2023BoosterTab = "VaccinePracticeAutumn2023BoosterTab",

    /**
     * Description: Vaccine - Autumn 2024 Booster tab
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    VaccinePracticeAutumn2024BoosterTab = "VaccinePracticeAutumn2024BoosterTab",

    /**
     * Description: Vaccine - Autumn 2025 Booster tab
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    VaccinePracticeAutumn2025BoosterTab = "VaccinePracticeAutumn2025BoosterTab",

    /**
     * Description: Vaccine - Enforce 12 year old age limit
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    VaccinePracticeEnforceUnder12Limit = "VaccinePracticeEnforceUnder12Limit",

    /**
     * Description: Vaccine Practice - Extended Booster Time Range Filter
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    VaccinePracticeExtendedBoosterTimeRangeFilter = "VaccinePracticeExtendedBoosterTimeRangeFilter",

    /**
     * Description: Vaccine Practice - Reduced Separation for Booster Doses
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    VaccinePracticeReducedBoosterDoseSeparation = "VaccinePracticeReducedBoosterDoseSeparation",

    /**
     * Description: Vaccine - Create Sanofi Clinics
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    VaccinePracticeSanofi = "VaccinePracticeSanofi",

    /**
     * Description: Vaccine Practice - See All Future Clinics
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    VaccinePracticeSeeAllFutureClinics = "VaccinePracticeSeeAllFutureClinics",

    /**
     * Description: Vaccine - Spring 2022 Booster tab
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    VaccinePracticeSpring2022BoosterTab = "VaccinePracticeSpring2022BoosterTab",

    /**
     * Description: Vaccine - Spring 2023 Booster tab
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    VaccinePracticeSpring2023BoosterTab = "VaccinePracticeSpring2023BoosterTab",

    /**
     * Description: Vaccine - Spring 2024 Booster tab
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    VaccinePracticeSpring2024BoosterTab = "VaccinePracticeSpring2024BoosterTab",

    /**
     * Description: Vaccine - Spring 2025 Booster tab
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    VaccinePracticeSpring2025BoosterTab = "VaccinePracticeSpring2025BoosterTab",

    /**
     * Description: Vaccine Practice - Strict Separation for Booster Doses
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    VaccinePracticeStrictBoosterDoseSeparation = "VaccinePracticeStrictBoosterDoseSeparation",

    /**
     * Description: Vaccine Practice - Strict Separation for Primary Doses
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    VaccinePracticeStrictPrimaryDoseSeparation = "VaccinePracticeStrictPrimaryDoseSeparation",

    /**
     * Description: Video Consult Desktop
     *
     * Is in modules: Video
     *
     * Scope: Any
     *
     * Allowed for unapproved users: True
     *
     **/
    VideoConsult = "VideoConsult",

    /**
     * Description: Video Consult - Embed Links
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    VideoConsultEmbed = "VideoConsultEmbed",

    /**
     * Description: Video Consult Large Rooms
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    VideoConsultLargeRooms = "VideoConsultLargeRooms",

    /**
     * Description: Video Consult Web
     *
     * Scope: Any
     *
     * Allowed for unapproved users: True
     *
     **/
    VideoConsultWeb = "VideoConsultWeb",

    /**
     * Description: Vision 3 Snomed Improvement
     *
     * Scope: Any
     *
     * Allowed for unapproved users: True
     *
     **/
    Vision3SnomedImprovement = "Vision3SnomedImprovement",

    /**
     * Description: Vision Medical Coding
     *
     * Alternative names: VisionSnomedCodeIntegrationImprovement
     *
     * Scope: Any
     *
     * Allowed for unapproved users: True
     *
     **/
    VisionIntegrationImprovement = "VisionIntegrationImprovement",

    /**
     * Description: Vision Partner API integration via Server
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    VisionPartnerApiServer = "VisionPartnerApiServer",

    /**
     * Description: Vision Prefer legacy API for demographics
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    VisionPreferLegacyApiForDemographics = "VisionPreferLegacyApiForDemographics",

    /**
     * Description: VoiceCall
     *
     * Scope: Any
     *
     * Allowed for unapproved users: True
     *
     **/
    VoiceCall = "VoiceCall",

    /**
     * Description: VOIP
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    Voip = "Voip",

    /**
     * Description: Enable wayfinder features
     *
     * Scope: OrgOnly
     *
     * Allowed for unapproved users: False
     *
     **/
    Wayfinder = "Wayfinder",

    /**
     * Description: Web - batch messaging in Web
     *
     * Is in modules: Web - Batch Messaging
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    WebBatchMessaging = "WebBatchMessaging",

    /**
     * Description: Web - Enable email notifications to group from assign
     *
     * Scope: Any
     *
     * Allowed for unapproved users: True
     *
     **/
    WebEmailGroupFromAssign = "WebEmailGroupFromAssign",

    /**
     * Description: Web - Org Wide Templates
     *
     * Scope: Any
     *
     * Allowed for unapproved users: True
     *
     **/
    WebOrgWideTemplates = "WebOrgWideTemplates",

    /**
     * Description: Patient Initiated - Enable PIFU
     *
     * Scope: OrgOnly
     *
     * Allowed for unapproved users: False
     *
     **/
    WebPatientLedFollowUp = "WebPatientLedFollowUp",

    /**
     * Description: Web - can send patient messages via email
     *
     * Scope: Any
     *
     * Allowed for unapproved users: True
     *
     **/
    WebPatientMessageEmails = "WebPatientMessageEmails",

    /**
     * Description: Disable Webview GPU acceleration
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    Webview2DisableGpuAcceleration = "Webview2DisableGpuAcceleration",

    /**
     * Description: Enables fallback for webview2 inbox
     *
     * Scope: Any
     *
     * Allowed for unapproved users: False
     *
     **/
    Webview2FallbackForInbox = "Webview2FallbackForInbox",

    /**
     * Description: Enable attachment preview in Inbox using Webview2
     *
     * Scope: Any
     *
     * Allowed for unapproved users: True
     *
     **/
    WebView2PreviewAttachments = "WebView2PreviewAttachments",

    /**
     * Description: Web - waiting list validation
     *
     * Scope: OrgOnly
     *
     * Allowed for unapproved users: False
     *
     **/
    WebWaitingListValidation = "WebWaitingListValidation",
}
